module.exports = __webpack_public_path__ + "img/croix_white.00064706.svg";